export enum AccessConstraintEnum {
  NONE = 'no',
  TRUCK_19T = '19t',
  TRUCK_7_5T = '7500k',
  TRUCK_3_5T = '3500k',
}
